import React from 'react';
import { Col, FormGroup, Row, OverlayTrigger, Tooltip, Glyphicon } from 'react-bootstrap';
import { Form, TextBox, UrlBox, CheckBox, EmailBox } from 'fw/forms';
import { SaveCancel, Label, Button } from 'fw/components';
import { Address, PhoneBox, BestContactTimeCombo, TimeZoneCombo } from 'areas/shared/controls'
import * as Modals from 'fw/globals/Modals';
import * as API from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import * as Notifications from 'fw/globals/Notifications';
import * as FormManager from 'fw/forms/form/FormManager';
import * as Help from 'modules/app/Help';
import * as App from 'modules/app/App';

class SponsorInfoTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            loading: true,
            title: "",
			disabled: !App.hasPrivilege("SponsorSetupEdit"),
            form: {
				phones: []
			}
        };
    }

    load = () => {
        // Nothing to load on this tab
    }

    get = () => {
        API.Sponsor.get('/sponsorSetup/getSponsorManagementInfo', {},
            {
                success: (r) => {
                    this.setState((prevState, props) => ({
                        loading: false,
                        form: r.data
                    }));
                },
                error: r => {
                    this.setState({ loading: false });
                }
            });
    }

    save = (rowVersion) => {
        const me = this;

        let rq = {
            sponsorId: this.state.form.sponsorId,
            sponsorName: this.state.form.sponsorName,
            website: this.state.form.website,
			phones: this.state.form.phones,
            address: this.state.form.address,
			mailingAddress: this.state.form.mailingAddress,
			sameMailingAddress: this.state.form.sameMailingAddress,
            rowVersion: rowVersion != null ? rowVersion : this.state.form.rowVersion,
        };

        API.Sponsor.post('/sponsorSetup/saveSponsorManagementInfo', rq,
            {
                success: (r) => {
                    Notifications.success(r.message);
                    me.get(r.data.entityId);
                },
                error: (r) => {
                    if (r.data && r.data.rowVersion) {
                        Modals.confirm(r.error.errorMessage,
                            function () {
                                me.save(r.data.rowVersion);
                            },
                            function () {
                                me.get(r.data.entityId);
                            }
                        );
                    } else {
                        Notifications.error(r.error.errorMessage);
                    }
                }
            });
    }

    cancel = () => {
        window.location.href = "/";
    }

    handleSubmit = () => {
		if (this._address !== null)
            this._address.register(this._form);
		if (this._mailingAddress !== undefined && this._mailingAddress !== null )
            this._mailingAddress.register(this._form);

		if (!this._form.validate())
            return false;

        this.save();
    }

    handleCancel = () => {
        const me = this;

        FormManager.checkUnsavedChanges(function () {
            me.cancel();
        })
    }

    handleChange = (form) => {
        this.setState({ form });
    }

    setHelp = () => {
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();
    }

    componentDidMount() {
        this.get();
        this.setHelp();
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
		
		if (this.state.form.phones.length === 0)
            this.handleAddPhone();
    }

	handleAddPhone = () => {
        const phones = this.state.form.phones

        phones.push({
            phoneTypeCode: 'MOBILE',
            number: '',
            extension: '',
            phoneId: -Math.abs(Date.now() | 0)
        });

        this.setState({
            phones
        });
    }

    handleRemovePhone = (i) => {
        const phones = this.state.form.phones;

        phones[i].number = '';
        phones.splice(i, 1);

        this.setState({ form: { ...this.state.form, phones } })
        this._form.handleFieldDirt()
    }

    handlePhoneChange = (v, i) => {
        const phones = this.state.form.phones

        phones[i] = v

        this.setState({ form: { ...this.state.form, phones } })
        this._form.handleFieldDirt()
    }

    handleAddressChange = (address) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					address: {
						addressId: address.addressId,
						street1: address.street1,
						street2: address.street2,
						zip: address.zip,
						city: address.city,
						stateCode: address.stateCode,
						county: address.county,
						province: address.province,
						countryCode: address.countryCode
					}
				}
			});
		});
    }

	checkBlankMailingAddressFields = (value) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					sameMailingAddress: value,
					mailingAddress: {
						addressId: prevState.form.mailingAddress != null ? prevState.form.mailingAddress.addressId : null,
						street1: "",
						street2: "",
						zip: "",
						city: "",
						stateCode: "",
						county: "",
						province: "",
						countryCode: "USA",
					}
				}
			});
		});
    }

	handleMailingAddressChange = (address) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					mailingAddress: {
						addressId: address.addressId,
						street1: address.street1,
						street2: address.street2,
						zip: address.zip,
						city: address.city,
						stateCode: address.stateCode,
						county: address.county,
						province: address.province,
						countryCode: address.countryCode,
					}
				}
			});
		});
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments, true);
    }

    handleAppReviewToolbar = (comments, canCompleteReview) => {
        this.handleUpdateComments(comments, canCompleteReview);
    }

    handleUpdateComments(comments, canCompleteReview) {
        let form = this.state.form;
        form.comments = comments;
        form.canCompleteReview = canCompleteReview;

        this.setState(form);
    }

	renderPhones = () => {
		const phoneTypes = ["Mobile", "Office"];

        return (
            this.state.form.phones.map((p, i) => (
                <div key={p.phoneId} className='form-inline'>
                    <PhoneBox
						types={phoneTypes}
                        value={p}
                        showExtension
                        onChange={(v) => this.handlePhoneChange(v, i)}
                        required={i === 0 ? "required" : ""}
                        ref={`phone_${i}`}
                    />
                    {i > 0 ?
                        <Button id="btnRemovePhone" bsStyle='link' title='Remove Phone' onClick={() => this.handleRemovePhone(i)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </Button> : null}
                </div>
            ))
        )
    }

    render() {
        if (this.state.loading)
            return null;

		const totalUsersTooltip = (
            <Tooltip id="totalUsersTooltip">
                Total users: {this.state.form.totalUsers}
                <br />
                Users with pending registration: {this.state.form.pendingUsers}
            </Tooltip>
        );

		const ppoc = this.state.form.primaryPointOfContact;

		return (
            <React.Fragment>
                <Row>
                    <Col md={5}>
                        <h3 className="inline">
                        Corporate Member Information
                        </h3>
                        <br /><br /><hr />
                    </Col>
					<Col md={7}>
                        <h3 className="inline">
                        Primary Point of Contact
                        </h3>
                        <br /><br /><hr />
                    </Col>
                </Row>
                {this.state.form.sponsorId !== null && this.state.form.sponsorId !== undefined ? 
                    <Form
                        onChange={this.handleChange}
                        onSubmit={this.handleSubmit}
                        values={this.state.form}
                        unsavedChangesWarning={true}
						disabled={this.state.disabled}
						ref={(form) => { this._form = form }} >
                        <Row>
                            <Col md={12}>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label required>Corporate Member Name</Label>
                                            <TextBox
                                                name="sponsorName"
                                                placeholder="Corporate Member Name"
                                                maxLength={70}
                                                required
                                                ref={(c) => { this.focusControl = c; }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>Corporate Member Website</Label>
                                            <UrlBox
                                                name='website'
                                                placeholder='Corporate Member Website'
                                                maxLength={200}
                                                required
                                            />
                                        </FormGroup>
										{this.state.form.phones !== null && this.state.form.phones.length > 0 && (
											<FormGroup>
												<Label htmlFor="phoneNumber" required>Phone Number(s)</Label>
												{this.renderPhones()}
											</FormGroup>
										)}
										{this.state.form.phones !== null && this.state.form.phones.length < 5 && (
											<Button id="btnAddPhone" bsStyle='default' bsSize='xsmall' className='pull-right' onClick={this.handleAddPhone}>
												Add Phone
												<Glyphicon glyph='plus' style={{ marginLeft: 10 }} />
											</Button>
										)}
                                    </Col>
									{ppoc !== null && 
										<React.Fragment>
											<Col md={3}>
												<FormGroup>
													<Label>First Name</Label>
													<TextBox
														disabled
														value={ppoc.firstName} />
												</FormGroup>
												<FormGroup>
													<Label>Last Name</Label>
													<TextBox
														disabled
														value={ppoc.lastName} />
												</FormGroup>
												<FormGroup>
													<Label>Title</Label>
													<TextBox
														disabled
														value={ppoc.title} />
												</FormGroup>
												<FormGroup>
													<Label>Email</Label>
													<EmailBox
														disabled
														value={ppoc.email} />
												</FormGroup>
											</Col>
											<Col md={4}>
												<FormGroup>
													<Label>Primary Phone</Label>
													<div className="form-inline">
														<PhoneBox value={ppoc.primaryPhone} showExtension disabled />
													</div>
												</FormGroup>
												<FormGroup>
													<Label>Best Time to be Contacted</Label>
													<BestContactTimeCombo value={ppoc.bestContactTimeCode} disabled />
												</FormGroup>
												<FormGroup>
													<Label>Which Time Zone are you located?</Label>
													<TimeZoneCombo value={ppoc.timeZoneCode} disabled />
												</FormGroup>
												<FormGroup>
													<Label>Payment Terms (Days)</Label>
													<TextBox
														disabled
														value= {ppoc.paymentTerms}/>
												</FormGroup>
											</Col>
										</React.Fragment>
									}
									{ppoc === null &&
										<Col md={7}>
											<Label style={{ color: 'red' }}>
                                				<em>There is no Primary Point of Contact set.</em>
											</Label>
										</Col>
									}
                                </Row>
                                <h3>Corporate Member Address</h3>
                                <hr />
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Address 
												name="address" 
												required 
												onChange={(address) => this.handleAddressChange(address)}
												ref={(c) => { this._address = c }} />
                                        </FormGroup>
										<CheckBox formControl={false} value={this.state.form.sameMailingAddress} onChange={this.checkBlankMailingAddressFields} name='sameMailingAddress' label='Mailing Address same as Corporate Address' />
                                    </Col>
                                </Row>
								{this.state.form !== null && !this.state.form.sameMailingAddress ? (
									<React.Fragment>
										<h3>Mailing Address</h3>
										<hr />
										<Row>
											<Col md={5}>
												<FormGroup>
													<Address 
														name="mailingAddress" 
														required 
														onChange={(address) => this.handleMailingAddressChange(address)} 
														ref={(c) => { this._mailingAddress = c }}
													/>
												</FormGroup>
											</Col>
										</Row>
									</React.Fragment>
								) : null}
                            </Col>
                        </Row>
                        {this.state.form.pendingUsers ?
                            <Row>
                                <Col md={12}>
                                    <Label style={{ color: 'red' }}>
                                        <em>
                                            <span className="required-indicator">*</span>
                                            &nbsp; At least one associated user has not completed their Registration
                                        </em>
                                        &nbsp;&nbsp;
                                        <OverlayTrigger placement="right" overlay={totalUsersTooltip}>
                                            <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                        </OverlayTrigger>
                                    </Label>
                                </Col>
                            </Row>
                            : null}
                        <hr />
                        <SaveCancel onCancel={this.handleCancel} disabled={this.state.disabled} />
                    </Form>
                :
                    <Row>
                        <Col md={12} className="text-center">
                            <h4 style={{ color: 'red' }}>
                                The user is not assigned to any Corporate Member yet.
                            </h4>
                            <h4>
                                Please contact <a href='mailto:certification@nvbdc.org'>certification@nvbdc.org</a> for more assistance.
                            </h4>
                        </Col>
                    </Row>
                }
            </React.Fragment>
        )
    }
}

export default SponsorInfoTab;



// WEBPACK FOOTER //
// ./src/areas/sponsor/sponsorSetup/sponsorInfo/SponsorInfoTab.js